"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceLogHeader = void 0;
const react_1 = __importDefault(require("react"));
const Title_1 = require("../../../Page/Title");
const BalanceLogAccountType_1 = require("../BalanceLogAccountType");
require("./index.scss");
const className = 'balance-log-header';
const BalanceLogHeader = (props) => {
    const { title, type } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Title_1.PageTitle, { text: title }),
        type && react_1.default.createElement(BalanceLogAccountType_1.BalanceLogAccountType, { type: type })));
};
exports.BalanceLogHeader = BalanceLogHeader;
//# sourceMappingURL=index.js.map